import { call, put, takeLatest } from 'redux-saga/effects'

import { api } from '../../services'

import { getCompanyDetail, getCompanyDetailSuccess, getCompanyDetailFailure } from './actions'

export function * requestCompanyDetail ({ payload: { id } }) {
  try {
    const { data: details } = yield call(api.getCompanyDetail, id)
    yield put(getCompanyDetailSuccess(details, { id }))
  } catch (e) {
    yield put(getCompanyDetailFailure(e.message || e, { id }))
  }
}

export default takeLatest(getCompanyDetail, requestCompanyDetail)
